<template>
	<div v-if="dataLoaded">
		<v-toolbar color="blue lighten-1" class="white--text">
			<v-icon color="white">monetization_on</v-icon>
			<v-toolbar-title>Kwoty projektu</v-toolbar-title>
		</v-toolbar>
		<div class="ma-4">
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Kwota wnioskowana</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					<div v-if="!amounts.requestedDonation">brak</div>
					<div v-else>{{formatMoney(amounts.requestedDonation) + " " + currencyCode}}</div>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Kwota przyznana</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					<div v-if="!amounts.summaryDonation">brak</div>
					<div v-else>{{formatMoney(amounts.summaryDonation) + " " + currencyCode}}</div>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Kwota zatwierdzona</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					<div v-if="!amounts.approvedDonation">brak</div>
					<div v-else>{{formatMoney(amounts.approvedDonation) + " " + currencyCode}}</div>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
	import {Numbers} from "../../../../utils/Numbers";
	import {AgencyProject} from "../../../../api/generated/AgencyProject";

	export default {
		name: "AgencyProjectSummaryAmountsView",

		mixins: [Numbers],

		data () {
			return {
				amounts: undefined,
				currencyCode: undefined
			};
		},

		created () {
			this.getProjectSummaryAmountsData();
			this.getCurrencyCode();
		},

		computed: {
			dataLoaded () {
				return this.amounts && this.currencyCode;
			}
		},

		methods: {
			getProjectSummaryAmountsData () {
				AgencyProject.getAmounts(this, this.$route.params.projectId, successResponse => {
						this.amounts = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować kwot projektu", errorResponse);
					});
			},

			getCurrencyCode () {
				AgencyProject.getCurrencyCode(this, this.$route.params.projectId, successResponse => {
						this.currencyCode = successResponse.code;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować waluty projektu", errorResponse);
					});
			}
		}
	};
</script>

<style scoped>

</style>